<template>
  <div v-if="version === 'v1'" class="shine-effect tw-group">
    <nuxt-link :to="`/blogs/${blog.url}`" :external="true" class="!tw-p-0">
      <div class="tw-relative">
        <library-image :src="blog.image" :title="blog.title" :alt="blog.title" :w-ratio="16" :h-ratio="9" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
          style="border-radius: var(--rounded)"
        ></div>
      </div>
      <h3 class="tw-mt-8 tw-line-clamp-2 tw-h-[60px] !tw-text-white" :style="`color: var(--c-${variables?.titleColor})!important`">{{ blog.title }}</h3>
      <p class="tw-mt-4 !tw-text-white tw-line-clamp-2 tw-h-[60px]"  :style="`color: var(--c-${variables?.textColor})!important`">{{ blog.description }}</p>
      <button class="outlined tw-mt-4 !tw-justify-start" :class="`n-${variables?.buttonTypeText || 'secondary'}`">
        VIEW MORE
        <span class="btn-arrow"> </span>
      </button>
    </nuxt-link>
  </div>

  
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { version } from '~/public/theme2/js/webflow';

export default defineNuxtComponent({
  name: 'Theme8BlogCard',

  mixins: [ComponentMixin],

  props: {
    blog: {
      required: true,
    },
    index: {
      required: true,
      type: Number,
    },

    version: {
      type: String,
      default: 'v1',
    },

    variables: {
      type: Object,
    },
  },

  computed: {
    ROUTES() {
      return ROUTES;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
